module.exports = __webpack_public_path__ + "img/Rajdhani-SemiBold.3b4fa999.png";